import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Scope } from 'informed';
import { Cell, Grid } from 'react-md';
import { get } from 'lodash-es';

import TextField from '../../Common/TextField';

import { isEmail, isPhone, isZIP } from './utils';

/**
 *
 * Description: Extention fields Component used by a natural party.
 *
 * @class
 */
class ExtendedPartyFieldsComponent extends Component {
  constructor(props) {
    super(props);

    const { selectedValueSubscriber } = props;

    this.state = {
      selectedValueSubscriber,
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let newState = null;
    if (get(nextProps, 'selectedValueSubscriber') !== get(prevState, 'selectedValueSubscriber')) {
      newState = { ...newState, selectedValueSubscriber: get(nextProps, 'selectedValueSubscriber') };
    }
    return newState;
  }

  render() {
    const { strings, readOnly } = this.props;
    const { selectedValueSubscriber } = this.state;

    const isValidPhone = phone => {
      const status = isPhone(phone);
      const message = get(strings, 'validation.message.invalid_phone', 'Numéro de téléphone non valide');
      return { status, message };
    };
    const isValidEmail = email => {
      const status = isEmail(email);
      const message = get(strings, 'validation.message.invalid_email', 'Adresse mail non valide');
      return { status, message };
    };
    const isValidZip = zip => {
      const status = isZIP(zip);
      const message = get(strings, 'validation.message.invalid_zip', 'ZIP non valide');
      return { status, message };
    };

    const phoneEmailBlock = () => {
      if (selectedValueSubscriber !== -1) return [];
      return (
        <>
          <Grid className="grid" style={{ width: '100%' }}>
            {/* PHONE */}
            <div key="phone" className={Cell.getClassName({ size: 6 })}>
              <TextField
                className="field text"
                key="phone"
                field="phone"
                id="field-phone"
                name="phone"
                shrink
                label={strings['block.transform.party.field.phone.label']}
                placeholder=""
                // onChange={value => this.setState({ selectedValue: value })}
                // value={selectedValue}
                disabled={readOnly}
                required
                validation={isValidPhone}
                strings={strings}
              />
            </div>
            {/* EMAIL */}
            <div key="email" className={Cell.getClassName({ size: 6 })}>
              <TextField
                className="field text"
                key="email"
                field="email"
                id="field-email"
                name="email"
                shrink
                label={strings['block.transform.party.field.email.label']}
                placeholder=""
                disabled={readOnly}
                required
                validation={isValidEmail}
                strings={strings}
              />
            </div>
          </Grid>
        </>
      );
    };
    return (
      <>
        {/* PHONE&EMAIL */}
        {phoneEmailBlock()}
        {/* ADDRESS */}
        <Grid className="grid" style={{ width: '100%' }}>
          {/* tips: to create array in scope => scope= {`extra[${index}]` */}
          <Scope scope="addresses[0]">
            {/* STREET */}
            <div key="name" className={Cell.getClassName({ size: 7 })}>
              <TextField
                className="field text"
                key="street"
                field="street"
                id="field-street"
                name="street"
                shrink
                label={strings['block.transform.party.field.street.label']}
                placeholder=""
                disabled={readOnly}
                required
                strings={strings}
              />
            </div>
            {/* ZIP */}
            <div key="zip" className={Cell.getClassName({ size: 2 })}>
              <TextField
                className="field text"
                key="zip"
                field="zip"
                id="field-zip"
                name="zip"
                shrink
                label={strings['block.transform.party.field.zip.label']}
                placeholder=""
                disabled={readOnly}
                required
                strings={strings}
                validation={isValidZip}
              />
            </div>
            {/* CITY */}
            <div key="city" className={Cell.getClassName({ size: 3 })}>
              <TextField
                className="field text"
                key="city"
                field="city"
                id="field-city"
                name="city"
                shrink
                label={strings['block.transform.party.field.city.label']}
                placeholder=""
                disabled={readOnly}
                required
                strings={strings}
              />
            </div>
          </Scope>
        </Grid>
      </>
    );
  }
}

ExtendedPartyFieldsComponent.propTypes = {
  value: PropTypes.string.isRequired, // eslint-disable-line
  strings: PropTypes.object.isRequired, // eslint-disable-line
  readOnly: PropTypes.bool.isRequired, // eslint-disable-line
  selectedValueSubscriber: PropTypes.number,
};

ExtendedPartyFieldsComponent.defaultProps = {
  selectedValueSubscriber: -1,
};

export default ExtendedPartyFieldsComponent;
